$('#contact_attachment').change(function() {
    $('#attachmentname').html($('#contact_attachment')[0].files[0].name);
    $('#attachmentname').css('display', 'block');
});

$('.nav-auxmob > button').click(function() {
    $('.burger').removeClass('__active');
    $('<div class="navwindow"></div>').hide();
    $('body').removeClass('__mobile');
    $('.navwrap').removeClass('__active');
    $('.navwrap')
        .find('ul')
        .removeClass('__active');
});

// Footer

$('.footer-navblock-nav > button').click(function() {
    $(this)
        .next('ul')
        .slideToggle();
    $(this).toggleClass('__active');
});

if ($('.header').hasClass('__sticky')) {
    var position = $(window).scrollTop();

    if ($(window).scrollTop() == 0) {
        $('.header').addClass('__showHeader');
    }
    $(window).on('scroll', function() {
        var header = $('.header');
        // var bannerHeight = $('.banner').height();
        var bannerHeight = 50;
        var scroll = $(window).scrollTop();

        // setting colour change
        if ($(window).scrollTop() > bannerHeight) {
            header.addClass('__stickyon');
            $('.icon-search, .burger-toggle').addClass('__black');
            $('.normlogo').css('display', 'none');
            $('.altlogo').css('display', 'block');
        } else if ($(window).scrollTop() < bannerHeight) {
            header.removeClass('__stickyon');
            $('.icon-search, .burger-toggle').removeClass('__black');
            $('.normlogo').css('display', 'block');
            $('.altlogo').css('display', 'none');
        }

        if ($(window).scrollTop() == 0) {
            header.removeClass('__stickyon');
            $('.icon-search, .burger-toggle').removeClass('__black');
            $('.normlogo').css('display', 'block');
            $('.altlogo').css('display', 'none');
        }

        // setting header to hide/show on scroll

        if (scroll > position) {
            $('.header').removeClass('__showHeader');
        } else {
            $('.header').addClass('__showHeader');
        }

        if (scroll < 10) {
            $('.header').addClass('__showHeader');
        }

        position = scroll;
    });
}

// set homepage header to position absolute by default
if ($('.auxbanner').length) {
    var lastScrollTop = 0;
    var header = $('.header');
    var auxHeight = $('.auxbanner').outerHeight();

    $('.header').css('position', 'absolute');
    header.css('opacity', '0');

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll > auxHeight) {
            header.css('position', 'fixed');
            header.removeClass('__transform');
            header.removeClass('__auxbanner');
        }

        if (scroll < auxHeight) {
            header.css('animation', 'none');
            header.css('position', 'absolute');
            header.addClass('__transform');
        }

        if (header.hasClass('__transform')) {
            header.css('transform', `translateY(${auxHeight}px)`);
            header.css('opacity', '1');
        } else {
            header.css('transition', 'none');
            var st = window.pageYOffset || $(document).scrollTop();
            header.css('transform', `translateY(0px)`);
            if (st > lastScrollTop) {
                header.slideUp(400);
            } else {
                header.slideDown(400);
            }
            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        }
    });

    // set navwrap top on mobile
    if ($(window).width() < 992) {
        $('.navwrap').css('top', `-${auxHeight}px`);
    }
}

// set videocta margin
if ($('.videocta').length) {
    var videoCta = $('.videocta');
    var videoCtaHeight = videoCta.outerHeight();
    videoCta.css('margin-top', `-${videoCtaHeight / 2}px`);
}
